var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0005 7H13.0005V5C13.0005 2.24 10.7605 0 8.00049 0C5.24049 0 3.00049 2.24 3.00049 5V7H2.00049C0.900488 7 0.000488281 7.9 0.000488281 9V19C0.000488281 20.1 0.900488 21 2.00049 21H14.0005C15.1005 21 16.0005 20.1 16.0005 19V9C16.0005 7.9 15.1005 7 14.0005 7ZM8.00049 16C6.90049 16 6.00049 15.1 6.00049 14C6.00049 12.9 6.90049 12 8.00049 12C9.10049 12 10.0005 12.9 10.0005 14C10.0005 15.1 9.10049 16 8.00049 16ZM11.1005 7H4.90049V5C4.90049 3.29 6.29049 1.9 8.00049 1.9C9.71049 1.9 11.1005 3.29 11.1005 5V7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.260fdcb8744cb3d1a796be376be43ea1.svg";
export { ForwardRef as ReactComponent };